// extracted by mini-css-extract-plugin
export default {"container":"buy-tickets_container__33qjd","label":"buy-tickets_label__2pro7","ticketIcon":"buy-tickets_ticketIcon__gO0Xn"};